import { AbstractIntlMessages } from 'next-intl';
import { ServerResponse } from 'http';
import { NoteDto } from './note';
import { User } from './user';

export interface SsrRequest {
  connection: { encrypted: boolean };
  headers: {
    host: string;
    [key: string]: string;
  };
  cookies: {
    [key: string]: string;
  };
}

export interface SsrQuery {
  slug: string[];
  [key: string]: string | string[];
}

export interface SsrParams {
  query: SsrQuery;
  req: SsrRequest;
  resolvedUrl: string;
  res?: ServerResponse;
}

export interface PrepareIndexSsrResult {
  locale?: string;
  messages?: object;
  url: string;
  workspaceId?: string | null;
  type: PageType;
  redirectUrl?: string;
  store: { [sid: string]: unknown };
  orgLogoUrl?: string | undefined;
}

export interface PrepareSsrResult {
  url: string;
  locale?: string;
  messages?: AbstractIntlMessages;
  workspaceId?: string | null;
  noteId?: string | null;
  type: PageType;
  redirectUrl?: string;
  note?: NoteDto | null;
  store: { [sid: string]: unknown };
  user?: User;
  orgLogoUrl?: string | undefined;
}

export interface PrepareSsrOptions {
  params?: SsrParams;
  query?: SsrQuery;
  cookies: { [key: string]: string };
  headers: { [key: string]: string };
  checkWorkspace?: boolean;
  orgId?: string;
}

export enum PreparessrResultType {
  NOTE = 'note',
  FOLDER = 'folder',
  TAG = 'tag',
  ALL = 'all',
  SETTINGS = 'settings',
  FATAL_ERROR = 'fatal_error',
  NOT_FOUND = 'not_found',
  REDIRECT = 'redirect',
  NOTE_NOT_FOUND = 'note_not_found',
  ORGANIZATION_NOT_FOUND = 'org_not_found',
  WORKSPACE_NOT_FOUND = 'workspace_not_found',
  ORG_SETTINGS = 'org_settings',
  TASKS = 'tasks',
  CHAT = 'chat',
  DASHBOARD = 'dashboard',
  FILES = 'files',
  NOTIFICATION_PANEL = 'notification',
  AUTOMATION = 'automation',
  CUSTOMIZER = 'customizer',
  AI_AGENTS = 'ai_agents',
}

export type PageType =
  | PreparessrResultType.NOTE
  | PreparessrResultType.FOLDER
  | PreparessrResultType.TAG
  | PreparessrResultType.ALL
  | PreparessrResultType.SETTINGS
  | PreparessrResultType.ORG_SETTINGS
  | PreparessrResultType.FATAL_ERROR
  | PreparessrResultType.NOT_FOUND
  | PreparessrResultType.REDIRECT
  | PreparessrResultType.NOTE_NOT_FOUND
  | PreparessrResultType.ORGANIZATION_NOT_FOUND
  | PreparessrResultType.WORKSPACE_NOT_FOUND
  | PreparessrResultType.TASKS
  | PreparessrResultType.CHAT
  | PreparessrResultType.DASHBOARD
  | PreparessrResultType.FILES
  | PreparessrResultType.NOTIFICATION_PANEL
  | PreparessrResultType.AUTOMATION
  | PreparessrResultType.CUSTOMIZER
  | PreparessrResultType.AI_AGENTS;
